import React from 'react';

import Button from '@pb/kit-component-button';
import {Icon, Icons} from '@pb/kit-component-icon';

type Props = {
    onDownload: () => void,
};

export const ExcelDownloadButton = ({onDownload}: Props) => {
    return (
        <Button onClick={onDownload} endIcon={<Icon type={Icons.EXCEL}/>} variant="Type.SECONDARY">Download
        </Button>
    );
};
